module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Joe drove halfway across Edinburgh wondering what his little girl had done this time to upset her mother. Gemma was nineteen. A bright girl. But with only a year of university under her belt, she’d decided to chuck it in. Announced one day that she was leaving Edinburgh to stay with Adam Wright, a distant cousin of her mother’s, for a while. When Adam’s parents died in a car crash a few years ago, he had inherited a stack of money and bought an ugly old warehouse of a building on the outskirts of Kirkwall in the Orkney Islands. Entirely founded on having had a few stories published in women’s magazines back in the early nineties, he set up a writers’ retreat, and installed himself as a sort of literary guru. Ruth couldn’t stand him. Probably because he’d once spilled red wine on her dress at a wedding reception. Gem, who had notions of becoming a poet, thought Adam was wonderful. And Adam was fond of her, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You can’t give up university just like that,’ Ruth had said the night Gemma told them of her plans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gem had an old school atlas open across her knees. She pointed to Edinburgh, then, with her finger, drew a line directly north. Beyond the Scottish coastline, she hit the group of islands where Adam’s retreat was located. She looked up. ‘Further east than you think.’ She smiled at Joe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruth stormed out of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m sure you’ll love it in Orkney,’ Joe said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She closed the atlas. ‘I better go see if Mum’s okay.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe called Adam a few days before Gem left and told him to "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("take good care of her. Adam promised she’d be well looked after. Really, he said, she was in extremely capable hands. Orkney was a lot safer than Edinburgh. Hardly any arseholes running around with baseball bats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He hung up when Joe told him what would happen if any harm came to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe’s fingers were tingling as he got out of the car. He locked it. Fumbled for his flat keys. Dropped them. He swore and picked them up off the pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He ran up the stairs. Couldn’t help himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruth opened the door the minute his key scratched in the lock. She was a mess. Her eyes looked like she’d scooped them out, dipped them in a tin of tomatoes and put them back in. She sniffed. Wiped her nose with the back of her hand. She said, ‘Gem.’ She turned her head. Wisps of dyed brown hair shrouded her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grabbed her hand. Snot slid around under his fingers. ‘Tell me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her hand slipped out of his grasp. She looked at him, lips stretched, gums pink and fleshy. He could have sworn she was grinning. Left of centre, a single strand of saliva bridged her lips. She said, ‘She’s dead.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He formed a fist. Slammed his knuckles into his open palm. He kicked the door. Let his hands drop. Ruth’s shoulders were shaking. Her jaw quivered. She looked hideously old.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Piss off.’ Joe wiped his hand on his trousers. ‘You’re a lying cow.’ He turned his back on her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t go.’ She grabbed his sleeve. ‘I need you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He swatted her hand away. Bile coated his tongue. He went to the bathroom. Locked the door. Spat in the sink. He felt dizzy. His armpits itched. He sat on the toilet and shouted through the door, ‘When did this happen?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come out.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("The smell of urine made him want to retch. He lurched towards the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grabbed a fistful of hair and pulled. His scalp hurt. He pulled harder. The pain was satisfying. He yelled. Then he caught sight of himself in the mirror. He let go. He looked ridiculous. A thirty-eight-year-old man trying to pull his hair out by the roots. Fucking ridiculous. ‘When I’m ready,’ he muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned against the sink. The cold tap dripped. He tightened it. No difference. Needed a new washer. Bugger it. He’d been meaning to get it fixed for a while. He watched drops of water explode against the grey enamel. Fascinating little liquid bombs. When he looked up at himself in the mirror he felt sick. Felt like he’d swallowed a bucket of phlegm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hands clammy, he turned the doorknob and pushed the door open. Ruth was huddled in the corner, facing him. ‘What happened?’ he asked her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t look at him. ‘Pills.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pills,’ he said, nodding. ‘Pills. What kind of pills?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Paracetamol.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stared at the swollen veins on the backs of his hands. Putting on a bit of weight, maybe. His wedding ring was too tight these days. He cleared his throat. He couldn’t say it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a while Ruth said it for him. ‘She killed herself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Standing on the finishing line, clutching the hare to your chest – and you can’t let go – as a thirty-five kilo greyhound sprints towards you. The dog rams you in the stomach. Bam. Joe struggled to get his breath back. Then, still panting, he said, ‘She wouldn’t do that. Not Gem. Not my daughter.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruth looked at him, her red eyes squeezing tears down her face. ‘The police said there were no suspicious circumstances.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stuck one of his knuckles in his mouth and bit it. It tasted salty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("‘She was depressed, Joe.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took his finger out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ruth said, ‘They have to do a post mortem.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, for fuck’s sake?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t get angry. It’s the law. They’re doing it as soon—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t want to know.’ He caught himself grabbing a handful of hair again. Stopped just in time. He shoved his hands in his pockets where they couldn’t do any damage. His legs were shaking. He’d have to sit down. ‘When did it happen?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Last night.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His hands sprang out of his pockets, fingers splayed. ‘And you didn’t tell me?’ Fingers so rigid they hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How could I?’ She pressed her back against the wall. ‘I tried.’ She put her head in her hands and spoke into her lap. ‘Your phone was turned off.’ She lifted her head, screamed. Joe raised his hands. Fucking racket. She stopped after a while. Took several rapid breaths. Then, quietly, she said, ‘I didn’t know where you were.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Could have tried Cooper’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nobody answered.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What, all night?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nobody answered.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Could have left a message.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I left hundreds of fucking messages on your fucking mobile.’ She screamed again. Then took a long wheezy breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joe said, patiently, ‘You could have left a message at Cooper’s.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yeah. Right. Hi, Sally. If you see Joe could you tell him his daughter’s dead? Brilliant, Joe. Where the fuck were you, anyway?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shrugged. ‘Out.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What, all night?’ She was mocking him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Happens. You know it happens.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("Now she was definitely grinning. ‘Young, huh? Was she? Pretty?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t start, Ruth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dark-haired? Nineteen? Blue eyes? Remind you of your daughter, Joe?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stop it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Remind you of Gem, eh?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shouted. ‘Stop it.’ He stepped towards her. ‘You’re fucking disgusting.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Was she good, Joe? Was she?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shouted, ‘Shut the fuck up.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She pushed her face towards his. ‘Answer me. Was she a good fuck, Joe?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He opened the door and hurried downstairs. Last thing he wanted was to batter the fuck out of Ruth. It wasn’t her fault her daughter was dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was the fault of the fucker who swore he’d look after her. Adam Wright had broken his promise. And now it was Joe’s turn to break something.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7322af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780857901729_08_ch2.vue
// module id = 78
// module chunks = 0